import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Hide({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Hide.Outline {...props} /> : <Hide.Solid {...props} />;
}

Hide.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      // Scale horizontally by 1.1 to elongate the eye, then center in the 24x24 viewBox
      <g transform="translate(0.3, 3) scale(1.1, 1)">
        <path
          d="M8.26484 11.7152C7.68984 11.1412 7.33984 10.3612 7.33984 9.48619C7.33984 7.73319 8.75184 6.32019 10.5038 6.32019C11.3708 6.32019 12.1688 6.67119 12.7338 7.24519"
          className="icon-outline"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6093 10.0473C13.3773 11.3373 12.3613 12.3553 11.0723 12.5893"
          className="icon-outline"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.15891 14.8207C3.57191 13.5747 2.22791 11.7547 1.25391 9.48569C2.23791 7.20669 3.59091 5.37669 5.18791 4.12069C6.77491 2.86469 8.60591 2.18269 10.5039 2.18269C12.4129 2.18269 14.2429 2.87469 15.8399 4.13969"
          className="icon-outline"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9517 6.33919C18.6397 7.25319 19.2447 8.30819 19.7537 9.48519C17.7867 14.0422 14.3107 16.7872 10.5037 16.7872C9.64068 16.7872 8.78968 16.6472 7.97168 16.3742"
          className="icon-outline"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3912 1.59799L2.61719 17.372"
          className="icon-outline"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Hide.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      // Scale horizontally by 1.1 to elongate the eye, then center in the 24x24 viewBox
      <g transform="translate(0.3, 3) scale(1.1, 1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7217 1.36736H10.7314C12.1266 1.36736 13.4827 1.7021 14.7314 2.3312L11.4729 5.62044C11.2388 5.58106 10.9851 5.55152 10.7314 5.55152C8.57535 5.55152 6.82901 7.31379 6.82901 9.48956C6.82901 9.74553 6.85827 10.0015 6.8973 10.2378L3.28754 13.8805C2.31193 12.7384 1.46315 11.3591 0.789982 9.77507C0.711933 9.59785 0.711933 9.38126 0.789982 9.19421C2.87779 4.29135 6.59486 1.36736 10.7217 1.36736ZM17.1607 4.03538C18.5753 5.33493 19.7753 7.08736 20.6729 9.19421C20.751 9.38126 20.751 9.59785 20.6729 9.77507C18.5851 14.6779 14.868 17.6118 10.7314 17.6118H10.7217C8.83876 17.6118 7.03388 16.9915 5.44364 15.8593L8.53632 12.7384C9.16071 13.1608 9.92169 13.4177 10.7314 13.4177C12.8778 13.4177 14.6241 11.6555 14.6241 9.48956C14.6241 8.67242 14.3705 7.9045 13.951 7.27441L17.1607 4.03538Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.161 4.03499L18.9366 2.24318C19.2293 1.95768 19.2293 1.48511 18.9366 1.1996C18.6537 0.914097 18.1952 0.914097 17.9025 1.1996L16.9854 2.12504C16.9757 2.14473 16.9562 2.16442 16.9366 2.18411C16.9269 2.2038 16.9074 2.22349 16.8879 2.24318L16.0196 3.12038L12.9269 6.24127L2.4586 16.8041L2.42933 16.8434C2.23421 17.129 2.27323 17.5237 2.51714 17.7699C2.65372 17.9166 2.84884 17.9855 3.03421 17.9855C3.21958 17.9855 3.40494 17.9166 3.55128 17.7699L13.9513 7.27402L17.161 4.03499ZM10.7319 11.941C12.0685 11.941 13.1611 10.8383 13.1611 9.48956C13.1611 9.07607 13.0636 8.68226 12.888 8.34753L9.60016 11.6653C9.93187 11.8425 10.3221 11.941 10.7319 11.941Z"
          className="icon-primary"
        />
      </g>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
